export default __webpack_public_path__ + "static/media/main-logo.e8f78926.png";